import {
  useRef,
} from 'react';

import {
  Icon,
  Popup,
  Tooltip,
  TextInput,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';
import * as ParentS from '../../styled';

type Props = {
  isOpen: boolean
  setIsOpen: { (isOpen: boolean): void },
  onInsert: { (url: string): void }
};

const LinkStyle = ({
  isOpen,
  setIsOpen,
  onInsert,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const onSubmit = () => {
    const url = inputRef.current?.value?.trim()
    if (url) onInsert(url)
    setIsOpen(false)
  }

  return (
    <Popup
      isOpen={isOpen}
      trigger={(
        <Flex>
          <Tooltip body="Insert Link" positions={['top']} >
            <ParentS.Control>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={14}
                height={14}
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
              </svg>
            </ParentS.Control>
          </Tooltip>
        </Flex>
      )}
      setPopupVisible={(e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
      }}
      onClickOutside={() => setIsOpen(false)}
    >
      <S.Dropdown
        onMouseDown={(e) => {
          // e.preventDefault();
          e.stopPropagation();
          // onToggle(type.style);
        }}
      >
        <Flex
          align="center"
          padding="10px 20px 5px 20px"
          spacing={10}
        >
          <TextInput
            inputRef={inputRef}
            height="2rem"
            padding="2px 8px"
            onKeyDown={(e: any) => {
              if (e.key === 'Enter') {
                onSubmit()
              }
            }}
          />
          <Flex
            clickable
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onSubmit()
              setIsOpen(false);
            }}
          >
            <S.PlusCircle />
          </Flex>
        </Flex>
      </S.Dropdown>
    </Popup>
  );
};

export default LinkStyle;
